import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import type { Preaching } from '../../types';

const BG = '#1C1C1E';
const CARD = '#2C2C2E';

export default function Preachings() {
  const [preachings, setPreachings] = useState<Preaching[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.from('preachings').select('*')
      .order('date', { ascending: false }).limit(50)
      .then(({ data }) => { setPreachings(data || []); setLoading(false); });
  }, []);

  return (
    <div className="min-h-screen pb-4" style={{ backgroundColor: BG }}>
      <div className="px-4 pt-2 pb-4">
        <h1 className="text-2xl font-bold text-white">Predicaciones</h1>
        <p className="text-sm mt-0.5" style={{ color: '#8E8E93' }}>Castillo del Rey Brisas</p>
      </div>

      {loading ? (
        <div className="px-4 space-y-4">
          {[1,2,3].map(i => (
            <div key={i} className="rounded-lg overflow-hidden animate-pulse" style={{ backgroundColor: CARD }}>
              <div className="h-44" style={{ backgroundColor: '#3A3A3C' }} />
              <div className="p-3 space-y-2">
                <div className="h-4 rounded" style={{ backgroundColor: '#3A3A3C', width: '75%' }} />
                <div className="h-3 rounded" style={{ backgroundColor: '#3A3A3C', width: '40%' }} />
              </div>
            </div>
          ))}
        </div>
      ) : preachings.length === 0 ? (
        <div className="mx-4 rounded-lg p-10 text-center" style={{ backgroundColor: CARD }}>
          <p className="text-4xl mb-3">🎙️</p>
          <p style={{ color: '#8E8E93' }}>No hay predicaciones disponibles</p>
        </div>
      ) : (
        <div className="px-4 space-y-4">
          {preachings.map((preaching) => (
            <Link
              key={preaching.id}
              to={`/preachings/${preaching.id}`}
              className="block rounded-lg overflow-hidden"
              style={{ backgroundColor: CARD }}
            >
              {preaching.thumbnail_url ? (
                <div className="relative">
                  <img
                    src={preaching.thumbnail_url}
                    alt={preaching.title}
                    className="w-full h-44 object-cover"
                  />
                  {/* Play overlay */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}>
                      <span className="text-white text-xl ml-1">▶</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="w-full h-32 flex items-center justify-center" style={{ backgroundColor: '#0D2B8E' }}>
                  <span className="text-4xl">🎙️</span>
                </div>
              )}
              <div className="p-3">
                <h3 className="font-bold text-white leading-tight">{preaching.title}</h3>
                {(preaching as any).speaker && (
                  <p className="text-sm mt-1" style={{ color: '#4A90D9' }}>👤 {(preaching as any).speaker}</p>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
